<template>
  <div class="box">
    <dl v-for='(item,index) in list' :key='index'>
      <dt><img :src="item.pic"></dt>
      <dd>
        <h3>{{item.title}}</h3>
        <p>{{item.subTitle}}</p>
        <router-link v-if="item.url == '' || item.url == null" :to="{path:'/learning/detail',query:{id:item.id}}">查阅详情</router-link>
        <div style="position: absolute;right: 30px;bottom: 25px;width: 104px;height: 32px;background: #2F935E;border-radius: 4px;text-align: center;line-height: 32px;color: #fff;font-size: 14px;cursor: pointer;" v-else @click="detaulUrl(item.url)">查阅详情</div>
      </dd>
    </dl>
  </div>
</template>

<script>
  import {
    news_list
  } from '@/axios/api.js'
  export default {
    data() {
      return {
        category: '',
        list: []
      }
    },
    methods: {
      detaulUrl(url) {
       window.open(url)
      },
    },
    mounted() {
      this.category = localStorage.getItem("category");
      var data = {
        category : this.category,
        start: 0,
        type:54,
        count: 100
      }
      news_list(data).then(res => {
        if (res.data.code == 0) {
          this.list = res.data.obj;
        } else {
          this.$message(res.data.msg);
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  }
</script>
<style scoped="scoped">
  .box{
    margin-top: 40px;
  }
  dl{
    height: 175px;
    box-shadow: 0px 1px 4px 0px rgba(0,21,41,0.12);
    margin-bottom: 20px;
    border-radius: 4px;
    overflow: hidden;
  }
  dl dt{
    float: left;
    width: 175px;
    height: 130px;
    margin: 20px 0 0 20px;
    background: linear-gradient(90deg, #3A99FE 0%, #39C5FF 100%);
  }
  dl dt img{
    width: 100%;
    height: 100%;
  }
  dl dd{
    height: 100%;
    width: calc(100% - 195px);
    float: left;
    padding: 16px 30px 15px 27px;
    position:relative;
  }
  dl dd h3{
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    margin-bottom: 15px;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  dl dd p{
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    margin-bottom: 25px;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  dl dd a{
    position: absolute;
    right: 30px;
    bottom: 25px;
    width: 104px;
    height: 32px;
    background: #2F935E;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    color: #fff;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/learning/marketing.vue